import React, { memo, useEffect, useRef, useState } from "react";
import { Text, TouchableOpacity, StyleSheet } from "react-native";
import { AntDesign as Icon } from "@expo/vector-icons";
import { FONT_FAMILY, THEME_COLORS } from "../themes";
const lodash = require("lodash");

interface SingleSelectProps {
  options: any[];
  labelExtractor?: string;
  valueExtractor?: string;
  pickerTitle?: string;
  value?: string | number;
  onChangeValue?: (any) => void;
}

const SingleSelect = ({
  options,
  labelExtractor,
  valueExtractor,
  pickerTitle,
  value,
  onChangeValue,
}: SingleSelectProps) => {
  const [visible, setVisible] = useState(false);
  const selected = useRef(value ?? options[0]);
  const wrapperRef = useRef(null);

  const onPress = async () => {
    setVisible((prev) => !prev);
  };

  const onChange = (item) => {
    selected.current = item;
    onChangeValue(item);
    setVisible((prev) => !prev);
  };

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setVisible(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      style={{ display: "flex", alignItems: "center", zIndex: 500 }}
    >
      <TouchableOpacity
        onPress={onPress}
        style={{ flexDirection: "row", alignItems: "center" }}
      >
        <Text
          style={{
            color: "#6300A3",
            fontFamily: FONT_FAMILY.three,
            fontSize: 13,
          }}
        >
          {labelExtractor
            ? lodash.get(selected.current, labelExtractor)
            : selected.current}
        </Text>
        <Icon
          name="caret-down"
          style={{ color: "#6300A3", fontSize: 10, marginLeft: 5 }}
        />
        {visible ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              position: "absolute",
              top: "1.6em",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "#F7F2FA",
              boxShadow: "0px 4px 12px rgba(48, 48, 48, 0.2)",
              borderRadius: 5,
              width: "fit-content",
              minWidth: 150,
              maxHeight: 480,
              overflow: "scroll",
            }}
          >
            {options.map((item) => {
              const isSelected = valueExtractor
                ? lodash.get(item, valueExtractor) ==
                  lodash.get(selected.current, valueExtractor)
                : item == selected.current;
              return (
                <TouchableOpacity
                  style={[
                    {
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      paddingVertical: 10,
                      paddingHorizontal: 12,
                      position: "relative",
                      zIndex: "400",
                    },
                    isSelected && { backgroundColor: THEME_COLORS.purple3 },
                  ]}
                  key={valueExtractor ? lodash.get(item, valueExtractor) : item}
                  onPress={() => onChange(item)}
                >
                  <Text
                    style={{
                      fontFamily: FONT_FAMILY.three,
                      color: "#303030",
                      fontSize: 13,
                    }}
                  >
                    {labelExtractor ? lodash.get(item, labelExtractor) : item}
                  </Text>
                  {isSelected ? <Icon name="check" /> : null}
                </TouchableOpacity>
              );
            })}
          </div>
        ) : null}
      </TouchableOpacity>
    </div>
  );
};

export default memo(SingleSelect);
